export const home = {
  // Navigation
  nav_spreadsheet: "Spreadsheet",
  nav_guides: "Guides",
  nav_categories: "Kategorier",
  nav_review: "Anmeldelse",
  nav_shipping: "Forsendelse",
  nav_safety: "Sikkerhed",
  nav_blog: "Blog",
  nav_home: "Hjem",
  nav_shopping_guide: "Indkøbsguide",
  nav_about: "Om os",
  nav_contact: "Kontakt",
  
  // Language selector
  lang_english: "English",
  lang_french: "Français",
  lang_german: "Deutsch",
  lang_danish: "Dansk",
  
  // Hero
  hero_eyebrow: "ALLCHINABUY SPREADSHEET RESSOURCE-HUB",
  hero_h1: "AllChinaBuy Spreadsheet — Find produkter, sælgere og købsressourcer hurtigere",
  hero_subheadline: "Opdag nyttige AllChinaBuy spreadsheets, betroede sælgerressourcer, produktguides, QC-oplysninger, forsendelsestips og købsguides — alt organiseret i ét simpelt hub.",
  hero_cta_primary: "Udforsk AllChinaBuy Spreadsheet",
  hero_cta_secondary: "Gennemse populære ressourcer",
  hero_trust: "Uafhængig ressource • Regelmæssigt opdateret • Bygget til nemmere produktdiscovering",
  
  // Search Module
  search_title: "Find den AllChinaBuy Spreadsheet ressource du har brug for",
  search_placeholder: "Søg produkter, sælgere, forsendelse, QC, lager...",
  search_button: "Søg",
  search_popular: "Populære søgninger",
  search_popular_items: "Tøj • Sko • Mode • QC • Forsendelse • Sælgere",
  
  // Spreadsheet Hub Section
  hub_h2: "AllChinaBuy Spreadsheet: Dit udgangspunkt",
  hub_copy: "Leder du efter produkter, sælgere eller nyttige købsoplysninger? Start med AllChinaBuy Spreadsheet hub og udforsk organiserede ressourcer efter kategori, produkttype og søgeintention.",
  hub_cta: "Udforsk Spreadsheet Hub →",
  
  // Popular Categories
  categories_h2: "Populære AllChinaBuy Spreadsheet kategorier",
  categories_clothing: "Tøj",
  categories_clothing_desc: "Gennemse det nyeste AllChinaBuy tøj-spreadsheet med betroede sælgere, kvalitetsvarer og størrelsesguides til streetwear og afslappet tøj.",
  categories_shoes: "Sko",
  categories_shoes_desc: "Udforsk AllChinaBuy sko-spreadsheet med sneakers, støvler, sandaler og mere fra verificerede sælgere med detaljerede QC-oplysninger.",
  categories_fashion: "Mode",
  categories_fashion_desc: "Opdag trendy modeartikler i AllChinaBuy spreadsheet — kuraterede samlinger, sæsonvalg og stilguides.",
  categories_electronics: "Elektronik",
  categories_electronics_desc: "Find elektronik og gadgets i AllChinaBuy produkt-spreadsheet, inklusive tilbehør, tech wearables og hverdagsenheder.",
  categories_accessories: "Tilbehør",
  categories_accessories_desc: "Køb bælter, tasker, smykker, ure og mere via AllChinaBuy tilbehør-spreadsheet med detaljerede sælgervurderinger.",
  categories_sellers: "Betroede sælgere",
  categories_sellers_desc: "Få adgang til AllChinaBuy betroet sælger-spreadsheet med verificerede anmeldelser, ratings og produktspecialiteter.",
  
  // Latest Resources
  resources_h2: "Seneste AllChinaBuy ressourcer",
  resources_read: "Læs guide →",
  pillar_h2: "AllChinaBuy Kerneguider",
  pillar_subtitle: "Dybdegående artikler der dækker hele AllChinaBuy købsrejsen",
  
  // Buying Guides
  guides_h2: "AllChinaBuy købsguides",
  guides_qc: "QC Guide",
  guides_qc_desc: "Lær at anmode om, læse og evaluere QC-fotos, før du sender dine AllChinaBuy ordrer.",
  guides_shipping: "Forsendelsesguide",
  guides_shipping_desc: "Sammenlign forsendelsesmetoder, forstå omkostninger, tidslinjer og vælg den bedste mulighed for dit land.",
  guides_warehouse: "Lagerguide",
  guides_warehouse_desc: "Forstå hvordan AllChinaBuy lagerprocessen fungerer — opbevaring, inspektion, pakning og afsendelse.",
  guides_seller: "Sælgerguide",
  guides_seller_desc: "Tips til at finde pålidelige sælgere, læse anmeldelser og undgå almindelige fejl ved indkøb.",
  guides_safety: "Sikkerhedsguide",
  guides_safety_desc: "Beskyt dig selv med bedste praksis for kontosikkerhed, betalingssikkerhed og svindelbevidsthed.",
  
  // Review Section
  review_h2: "AllChinaBuy Anmeldelse",
  review_copy: "Leder du efter en upartisk oversigt? Udforsk vores AllChinaBuy anmeldelse med vigtige funktioner, indkøbsworkflow, lageroplysninger, forsendelsesovervejelser, sikkerhedstips og vigtige ting at vide før brug af platformen.",
  review_cta: "Læs AllChinaBuy Anmeldelse →",
  
  // Safety Section
  safety_h2: "Shop klogere: AllChinaBuy Sikkerhedsguide",
  safety_copy: "Før du køber, forstå sælgerverifikation, QC-fotos, betalingssikkerhed, mistænkelige links, kontobeskyttelse og almindelige indkøbsrisici.",
  safety_cta: "Læs Sikkerhedsguide →",
  
  // Final CTA
  final_cta_h2: "Klar til at udforske AllChinaBuy ressourcer?",
  final_cta_copy: "Start med AllChinaBuy Spreadsheet og opdag produkt-, sælger-, forsendelses- og købsressourcer organiseret til hurtigere research.",
  final_cta_primary: "Udforsk AllChinaBuy Spreadsheet",
  final_cta_secondary: "Besøg vores hovedwebsite",
  
  // Category Dropdown
  dropdown_title: "Indkøbskategorier",
  dropdown_all: "Alle kategorier",
  
  // Main CTAs
  btn_main_site: "AllChinaBuy Spreadsheet",
  btn_buy_now: "Køb nu",
  
  // Footer
  footer_spreadsheet: "Spreadsheet",
  footer_guides: "Guides",
  footer_reviews: "Anmeldelser",
  footer_shipping: "Forsendelse",
  footer_safety: "Sikkerhed",
  footer_resources: "Ressourcer",
  footer_about: "Om os",
  footer_contact: "Kontakt",
  footer_privacy: "Privatlivspolitik",
  footer_terms: "Vilkår",
  footer_disclaimer: "Disclaimer",
  footer_disclaimer_text: "AllChinaBuy Spread er en uafhængig informationsressource og er ikke tilknyttet eller drevet af AllChinaBuy, medmindre det udtrykkeligt er angivet.",
  footer_copyright: "© 2026 AllChinaBuy Spreadsheet. Alle rettigheder forbeholdes.",
  
  // Meta
  meta_title: "AllChinaBuy Spreadsheet 2026: Komplet Guide & Bedste Ressourcer",
  meta_description: "Opdag AllChinaBuy Spreadsheet — din uafhængige ressource-hub for produkter, sælgere, QC-guides, forsendelsestips og købsressourcer. Regelmæssigt opdateret.",
  
  // Category names (for dropdown)
  cat_shoes: "Sko",
  cat_hoodies: "Hoodies/Sweaters",
  cat_tshirts: "T-Shirts",
  cat_jackets: "Jakker",
  cat_pants: "Bukser/Shorts",
  cat_headwear: "Hovedbeklædning",
  cat_sets: "Sæt",
  cat_underwear: "Undertøj",
  cat_jersey: "Trøjer",
  cat_accessories: "Tilbehør",
  cat_bags: "Tasker",
  cat_belts: "Bælter",
  cat_perfumes: "Parfumer",
  cat_other: "Andet",
};